import { FiCheck, FiFileText, FiUpload } from "react-icons/fi";

const ACCEPT = ".pdf,.jpg,.jpeg,.png,.webp";
const MAX_FILE_SIZE = 10 * 1024 * 1024;

export const DocumentUpload = ({ label, hint, fileName = "", onSelect, optional = false }) => {
  const attached = Boolean(fileName);

  const handleChange = (event) => {
    const selected = event.target.files?.[0];
    event.target.value = "";

    if (!selected) return;

    if (selected.size > MAX_FILE_SIZE) {
      onSelect(null, "Arquivo muito grande. Envie arquivos de até 10 MB.");
      return;
    }

    onSelect(selected);
  };

  return (
    <div className="individual-onboarding-doc-item">
      <span className="mb-1.5 block text-xs font-medium text-gray-500">
        {label}
        {optional ? " (opcional)" : ""}
      </span>

      <label
        className={`individual-onboarding-upload ${attached ? "individual-onboarding-upload--filled" : ""}`}
      >
        <input
          type="file"
          accept={ACCEPT}
          className="individual-onboarding-upload__file-input"
          onChange={handleChange}
        />

        {attached ? (
          <FiFileText className="mb-2 h-7 w-7 text-[#e7a73f]" aria-hidden="true" />
        ) : (
          <FiUpload className="mb-2 h-7 w-7 text-gray-400" aria-hidden="true" />
        )}
        <span className="individual-onboarding-upload__name">
          {fileName || "Clique para enviar"}
        </span>
        <span className="mt-1 line-clamp-2 text-xs text-gray-500">{hint}</span>
        {attached ? (
          <span className="mt-2 inline-flex items-center gap-1 text-[11px] font-semibold text-[#e7a73f]">
            <FiCheck className="h-3.5 w-3.5" aria-hidden="true" />
            Documento anexado
          </span>
        ) : null}
      </label>
    </div>
  );
};
